import './App.css';
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import LoginPage from './pages/LoginPage';
import SignupPage from './pages/SignupPage';
import MainPage from './pages/MainPage';
import LandingPage from './pages/LandingPage';
import PrivateRoute from "./components/PrivateRoute";

function App() {
  return (
      <Router>
        <Routes>
            <Route path="/" element={
                        <LandingPage />
                }
            />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/signup" element={<SignupPage />} />
          <Route path="/charlotte" element={
              <PrivateRoute>
                  <MainPage />
              </PrivateRoute>
              } />
        </Routes>
      </Router>
  );
}

export default App;

